<script>
import formatCurrency from "@utils/format-currency";
import formatPaymentMethod from "@utils/format-payment-method";
import  { formatOrder } from "@utils/format-order";
import { authComputed, merchantComputed } from "@store/helpers";
import { orderAtmInfoList, orderIsCanPay, orderVaccInfoList } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";

export default {
  components: {
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.orderItem.byOrderExtrafields || {};

      return !!Object.keys(orderExtrafields)[0];
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    /* orderList() {
      return [
        {
          title: `${this.orderItem.prepaid.title}x1 (可抵用<span title="${this.orderItem.times}">${prepaidFormatUsedTimes(this.orderItem.times)}</span>次)`,
          text: `NT$ ${formatCurrency(this.orderItem.prepaid.price)}`,
          textClass: 'font-number',
        },
        {
          type: 'hr',
        },
        {
          title: `<span class="text-${formatOrder(this.orderItem.status).color} fw-semi-bold">${formatOrder(this.orderItem.status).title}</span><br><span class="text-gray-2 fs-2sm">${formatOrder(this.orderItem.status, this.orderItem).paidInfo}</span>`,
          text: `${formatPrice(this.orderItem.price)}`,
          class: 'align-items-end mt-2',
          textClass: `font-number fs-2xl fw-semi-bold text-${formatOrder(this.orderItem.status).infoColor}`,
        }
      ]
    }, */
    orderBillingTotal() {
      const orderStatus = formatOrder(this.orderItem)
      return conditionList([
        {
          title: `<span class="text-${orderStatus.color} fw-semi-bold">${orderStatus.title}</span><br><span class="text-gray-2 fs-2sm">${orderStatus.paidInfo}</span>`,
          text: `${formatPrice(this.orderItem.orders.items[0].params[0].total)}`,
          class: 'align-items-end',
          textClass: `font-number fs-xl fw-semi-bold text-${orderStatus.infoColor}`,
          // condition: () => {
          //   return type === 'order'
          // },
        }
      ])
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.orderItem, unpaid: this.orderItem.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.orderItem, unpaid: this.orderItem.priceTotal })
    },
  },
  mounted(){
  },
  methods: {
    formatCurrency,
    formatPaymentMethod,
    formatOrder,
    orderIsCanPay,
    orderList(item) {
      return conditionList([
        {
          title: `<i class="fontello fontello-paw fs-sm mr-2 text-primary"></i>${item.deposit.title}
          `,
          text: `${
              item.params[0].levelDiscount > 0 ?
              `<span class="text-gray-2">
                會員價：NT$ ${formatCurrency(item.params[0].total)}
              </span>
              <br>
              <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${formatCurrency(item.params[0].price)}</span>
              `
              : 
              item.deposit.price}
            `,
          textClass: 'font-number',
        },
        {
          type: 'hr',
        },
        {
          title: `小計`,
          text: `${formatPrice(item.priceTotal)}`,
          class: 'align-items-end',
          textClass: `font-number`,
        }
      ])
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.detailOrderItemReservation">
    <div class="detailOrderItemReservation__box">
      <div
        v-for="(item, $index) in orderItem.orders.items"
        :key="$index" 
        class="detailOrderItemReservation__item"
      >
        <BaseList
          :data-list="orderList(item)"
          type="order"
        />
      </div>
      <div class="">
        <BaseList
          :data-list="orderBillingTotal"
          type="order"
        />
      </div>
    </div>
    <template v-if="orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]">
      <hr>
      <BaseList
        :data-list="vaccInfoList"
        type="info"
      />
    </template>
    <template v-if="orderItem.paymentMethod === 'Atm' && !!atmInfoList[0]">
      <hr>
      <BaseList
        :data-list="atmInfoList"
        type="info"
      />
    </template>
    <OrderPaymentButton
      :order-item="orderItem"
      type="deposit"
      button-class="mt-5"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.detailOrderItemReservation {

  :global {
    .detailOrderItemReservation {
      &__box {
        border: 1px solid rgba($color-line, 0.5);
        padding: 1.875rem;
      }
      &__item {
        &:not(:last-child) {
          margin-bottom: 1rem;
        }
      }
      &__no {
        padding: 1rem;
        margin-bottom: 2rem;
        font-size: 0.875rem;
        background: rgba($color-blue, 0.5);
        border-radius: 6px;
      }
    }
  }
}
</style>
